$(document).ready(function () {
	$("#project_slider").slick({
		slide: ".slide",
		rows: 0,
		autoplay: false,
		autoplaySpeed: 0,
		speed: 300,
		pauseOnFocus: false,
		pauseOnHover: false,
		pauseOnDotsHover: false,
		fade: false,
		infinite: true,
		draggable: false,
		arrows: true,
		dots: true,
		variableWidth: false,
		slidesToShow: 2,
		slidesToScroll: 2,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					draggable: true,
					arrows: true,
				}
			}
		]
	});

	$("#testimonials_slider").slick({
		slide: ".testimonial_slide",
		rows: 0,
		autoplay: false,
		autoplaySpeed: 0,
		speed: 300,
		pauseOnFocus: false,
		pauseOnHover: false,
		pauseOnDotsHover: false,
		fade: false,
		infinite: true,
		draggable: false,
		arrows: true,
		dots: true,
		variableWidth: false,
		slidesToShow: 1,
	});
});

